import * as React from 'react';
import { cn } from '@/lib/utils';

interface SkeletonProps {
  className?: string;
  variant?: 'line' | 'card' | 'table-row' | 'stat-card' | 'circle';
}

function SkeletonBase({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'rounded bg-gradient-to-r from-cs-surface-raised via-cs-surface-hover to-cs-surface-raised bg-[length:200%_100%] animate-shimmer',
        className
      )}
      aria-hidden="true"
    />
  );
}

export function Skeleton({ variant = 'line', className }: SkeletonProps) {
  if (variant === 'stat-card') {
    return (
      <div className="bg-cs-surface-card border border-cs-border rounded-lg p-4 space-y-3">
        <SkeletonBase className="h-3 w-20" />
        <SkeletonBase className="h-7 w-16" />
      </div>
    );
  }
  if (variant === 'card') {
    return (
      <div className="bg-cs-surface-card border border-cs-border rounded-lg p-4 space-y-3">
        <div className="flex items-center gap-3">
          <SkeletonBase className="w-8 h-8 rounded-lg flex-shrink-0" />
          <div className="flex-1 space-y-1.5">
            <SkeletonBase className="h-3.5 w-32" />
            <SkeletonBase className="h-3 w-24" />
          </div>
        </div>
        <SkeletonBase className="h-3 w-full" />
        <SkeletonBase className="h-3 w-3/4" />
      </div>
    );
  }
  if (variant === 'table-row') {
    return (
      <div className="flex items-center gap-4 py-3 px-4">
        <SkeletonBase className="h-3.5 flex-1" />
        <SkeletonBase className="h-3.5 w-20" />
        <SkeletonBase className="h-5 w-16 rounded" />
        <SkeletonBase className="h-3.5 w-12" />
      </div>
    );
  }
  if (variant === 'circle') {
    return <SkeletonBase className={cn('rounded-full', className)} />;
  }
  return <SkeletonBase className={cn('h-4 w-full', className)} />;
}
